// tasks
import { sleep } from '../webrtc/helpers';

let tasks = [];

function checkTasksRemaining() {
  const loader = document.querySelector('.status-indicator');
  if (!loader) return;
  loader.classList.remove('hidden');
  if (tasks.length) {
    loader.classList.remove('hide');
  } else {
    loader.classList.add('hide');
  }
  //   window.setTimeout(function(){
  updateUI();
//   }, 500)
}

function done(task) {
  // update UI of task
  const check = document.querySelector(`#task_${task.id} .done`);
  if (check) check.classList.remove('hidden');
  if (task.isDeterminate){
    const loader = document.querySelector(`#task_${task.id} .determinate-loading`);
    if (loader) loader.classList.add('hidden');
  } else{
    const loader = document.querySelector(`#task_${task.id} .indeterminate-loading`);
    if (loader) loader.classList.add('hidden');
  }

  // find task and remove it from the list
  window.setTimeout(() => {
    removeTask(task.id);
  }, 1000);
}
function error(task) {
  // update UI of task
  const error = document.querySelector(`#task_${task.id} .error`);
  if (error) error.classList.remove('hidden');
  const loader = document.querySelector(`#task_${task.id} .loader`);
  if (loader) loader.classList.add('hidden');
  // find task and remove it from the list
  window.setTimeout(() => {
    removeTask(task.id);
  }, 5000);
}

function update(task, progress) {
  if (task.isDeterminate == false){
    return
   }
    const loadingEl = document.querySelector(`#task_${task.id} .determinate-loading`);
    updateLoadingIndicator(loadingEl, 'default', progress);
    document.querySelector(`#task_${task.id} .progress-indicator`).innerHTML = progress;

  let last_progress = 0;
  return {
    update: async (progress) => {
      for (let i = last_progress; i < progress; i++) {
        await sleep(200 / (progress - last_progress));
        update(task, i);
      }
      last_progress = progress;
    },
    done: () => done(task),
    error: () => error(task),
  };
}

function addTask(task) {
  tasks.push(task);
  checkTasksRemaining();
  let last_progress = 0;
  return {
    update: async (progress) => {
      for (let i = last_progress; i < progress; i++) {
        await sleep(200 / (progress - last_progress));
        update(task, i);
      }
      last_progress = progress;
    },
    done: () => done(task),
    error: () => error(task),
    valid: () => {
      return tasks.filter((t) => t.id == task.id).length > 0;
    }
  };
}

function removeTask(id) {
  // find task and remove it from the list
  tasks = tasks.filter((task) => task.id !== id);
  checkTasksRemaining();
}

function taskHTML(id, message) {
  return `<div class='task' id='task_${id}'>
    <div class='done hidden'>
    <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 text-green-500 fill-current" viewBox="0 0 512 512"><title>ionicons-v5-e</title><path d="M256,48C141.31,48,48,141.31,48,256s93.31,208,208,208,208-93.31,208-208S370.69,48,256,48ZM364.25,186.29l-134.4,160a16,16,0,0,1-12,5.71h-.27a16,16,0,0,1-11.89-5.3l-57.6-64a16,16,0,1,1,23.78-21.4l45.29,50.32L339.75,165.71a16,16,0,0,1,24.5,20.58Z"/></svg>
    </div>
    <div class='error hidden'>
    <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 text-red-500 fill-current" viewBox="0 0 20 20"><path d="M10 1.6a8.4 8.4 0 1 0 0 16.8 8.4 8.4 0 0 0 0-16.8zm4.789 11.461L13.06 14.79 10 11.729l-3.061 3.06L5.21 13.06 8.272 10 5.211 6.939 6.94 5.211 10 8.271l3.061-3.061 1.729 1.729L11.728 10l3.061 3.061z"/></svg>
    </div>
    <div class="determinate-loading"></div>
    <div class="indeterminate-loading mr-4">
		<svg class="animate-spin  h-5 w-5 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
			<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
			<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
		</svg>

    </div>
    ${message}
    <span class="progress-indicator"></span>
    </div>`;
}

const order = [0, 1, 2, 3, 4, 9, 14, 19, 24, 23, 22, 21, 20, 15, 10, 5, 6, 7, 8, 13, 18, 17, 16, 11, 12];
const filledColor = '#001cff';
function setupIndicator(el) {
  for (let i = 0; i < 25; i++) {
    const div = document.createElement('div');
    el.append(div);
  }
}
function updateLoadingIndicator(el, style, progress) {
  const count = parseInt(progress / 100.0 * 25);
  if (count > 25) return;
  if (style == 'square') {
    el.children[order[count]].style.background = filledColor;
  } else {
    if (el.children && el.children[count]) el.children[count].style.background = filledColor;
  }
}

function updateUI() {
  const taskList = document.querySelector('.status-indicator .tasks');
  taskList.innerHTML = '';
  tasks.forEach((task) => {
    taskList.innerHTML += taskHTML(task.id, task.message);
    if (task.isDeterminate){
      const loadingEl = document.querySelector(`#task_${task.id} .determinate-loading`);
      setupIndicator(loadingEl);
    } else{
      // show spinner
      const loadingEl = document.querySelector(`#task_${task.id} .indeterminate-loading`);
      loadingEl
    }
  });
}

export { addTask };
